/* eslint-disable @typescript-eslint/no-explicit-any */
import { FlexContainer, Label, Modal, setColorTheme } from '@facephi/ui-react';
import styled from 'styled-components';

export const StyledModalImageFooter = styled(FlexContainer)`
  background-color: ${setColorTheme('grey800')};
  border-radius: 0 0 0.8rem 0.8rem;
  height: 6rem;
  min-height: 6rem;
`;

export const StyledModalImageStyles = styled(Modal)`
  min-height: 50rem;
  width: 100rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
`;

export const StyledModalImageSource = styled('div')`
  overflow: hidden;
  position: relative;
  flex: 1;
  img {
    position: absolute;
    max-width: 100%;
    object-fit: cover;
    height: 100%;
    left: 50%;
  }
`;

export const StyledModalImageHeader = styled(FlexContainer)`
  border-bottom: 1px solid ${setColorTheme('grey200')};
  height: 6rem;
  min-height: 6rem;
  padding: 0 2.4rem;
  background-color: ${setColorTheme('grey800')};
  border-radius: 0.8rem 0.8rem 0 0;
`;

export const StyledModalImageZoom = styled(Label)`
  background-color: ${setColorTheme('grey600')};
  height: 4rem;
  padding: 0 1.6rem;
  border-radius: 0.8rem;
  display: flex;
  align-items: center;
  width: 7.2rem;
` as any;
